import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';
import { CardConfiguration } from './card-configuration';
import { CatalogProductsService } from 'app/core/services/catalog-products.service';

declare var moment: any;

export class EventCardConfiguration extends CardConfiguration {
    constructor(course: any, service: CatalogProductsService) {
        super();
        // console.log(course);
        let hoursSinceRelease=moment.duration(moment().diff(moment(course.releaseDate, "YYYY.MM.DD HH:mm").toDate())).asHours();
        this.tagType = 'class';
        this.classType = (hoursSinceRelease <= 72 && !course.expired) ? 'New Event': 'Event';
        this.thumbnail = course.virtualVenue ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/classroom-class.png' :
            'https://itpx-branded-portal-dev.s3.amazonaws.com/online-class.png';
        this.expired = course.expired;
        this.clickable = true;  //Always true since available till is on assignment lvl, this is classEvent lvl
        this.target = ['/app', 'class', course.id];
        this.hideInstructor = true;
        this.action = LinkActions.ACTION;
        this.hideLocation = true;
        this.links = [{
            disabled: false, tooltip: null,
            type: LinkActions.ACTION,
            url: this.clickable ? this.target : [],
            action: (event) => service.joinEvent(event),
            text: 'Join Event'
        }];
        // this.expired = course.expired;
        // this.clickable = false;
        // this.target = [];
        // this.links = course.productVariant && course.productVariant.hosted &&
        //     course.certificate && course.certificate.certLocation ? [{
        //         disabled: !course.certificate || !course.certificate.certLocation,
        //         tooltip: !course.certificate || !course.certificate.certLocation ?
        //             'branded.portal.courses.exam.material.tooltip.text' : null,
        //         url: [],
        //         type: LinkActions.ACTION,
        //         text: 'Join event'
        //     //     action: (assignment) => certificateService.getCertificateFile(course.certificate.certLocation, course.certificate.displayName),
        //     //     text: translateHandlebarsPipe.transform('branded.portal.courses.exam.material.text', course),
        //     //     image: !course.certificate.certLocation ? 'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate-inactive.svg' :
        //     //         'https://itpx-branded-portal-dev.s3.amazonaws.com/file-certificate.svg'
        //     }] : [];
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/course/configurations/event-card-configuration.ts